import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Accessibility,
  Plus,
  Minus,
  Contrast,
  Link2,
  Pause,
  RotateCcw,
  X,
} from "lucide-react";
import { useAccessibility } from "@/contexts/AccessibilityContext";

const AccessibilityWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    fontSize,
    highContrast,
    highlightLinks,
    reduceMotion,
    increaseFontSize,
    decreaseFontSize,
    toggleHighContrast,
    toggleHighlightLinks,
    toggleReduceMotion,
    resetAll,
  } = useAccessibility();

  const menuItems = [
    {
      icon: Plus,
      label: "הגדל גופן",
      onClick: increaseFontSize,
      active: fontSize !== "normal",
      disabled: fontSize === "larger",
    },
    {
      icon: Minus,
      label: "הקטן גופן",
      onClick: decreaseFontSize,
      active: false,
      disabled: fontSize === "normal",
    },
    {
      icon: Contrast,
      label: "ניגודיות גבוהה",
      onClick: toggleHighContrast,
      active: highContrast,
    },
    {
      icon: Link2,
      label: "הדגש קישורים",
      onClick: toggleHighlightLinks,
      active: highlightLinks,
    },
    {
      icon: Pause,
      label: "עצור אנימציות",
      onClick: toggleReduceMotion,
      active: reduceMotion,
    },
    {
      icon: RotateCcw,
      label: "איפוס הגדרות",
      onClick: resetAll,
      active: false,
    },
  ];

  return (
    <div className="fixed bottom-24 left-4 z-[100]">
      {/* Toggle Button */}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 rounded-full bg-navy hover:bg-navy-light text-cream shadow-lg border-2 border-gold p-0"
        aria-label={isOpen ? "סגור תפריט נגישות" : "פתח תפריט נגישות"}
        aria-expanded={isOpen}
        aria-controls="accessibility-menu"
      >
        {isOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <Accessibility className="w-6 h-6" />
        )}
      </Button>

      {/* Menu */}
      {isOpen && (
        <div
          id="accessibility-menu"
          role="menu"
          aria-label="אפשרויות נגישות"
          className="absolute bottom-16 left-0 w-64 bg-cream rounded-xl shadow-2xl border border-border overflow-hidden animate-fade-up"
        >
          <div className="bg-navy text-cream px-4 py-3">
            <h3 className="font-bold text-lg flex items-center gap-2">
              <Accessibility className="w-5 h-5" />
              הגדרות נגישות
            </h3>
          </div>

          <div className="p-2 space-y-1">
            {menuItems.map((item) => (
              <button
                key={item.label}
                onClick={item.onClick}
                disabled={item.disabled}
                role="menuitem"
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-right transition-colors ${
                  item.active
                    ? "bg-gold/20 text-navy font-semibold"
                    : "hover:bg-muted text-foreground"
                } ${item.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
                aria-pressed={item.active}
              >
                <item.icon className={`w-5 h-5 ${item.active ? "text-gold" : ""}`} />
                <span>{item.label}</span>
                {item.active && (
                  <span className="mr-auto text-xs bg-gold text-navy px-2 py-0.5 rounded-full">
                    פעיל
                  </span>
                )}
              </button>
            ))}
          </div>

          <div className="bg-muted px-4 py-2 text-xs text-muted-foreground text-center">
            תקן נגישות ישראלי 5568
          </div>
        </div>
      )}
    </div>
  );
};

export default AccessibilityWidget;
